<template>
  <div class="centered-container">
    <b-spinner style="width: 5rem; height: 5rem; margin-bottom: 1rem;" variant="primary" />
    <p>Redirecting to login page</p>
  </div>
</template>

<script>
import { auth } from '@/middleware/auth';
import router from "@/router";

export default {
  name: "Login",
  components: {
  },
  data() {
    return {};
  },
  computed: {},
  beforeMount: async () => {
    if (!auth.isUserSignedIn()) {
      try {
        auth.getSession();
      } catch (err) {
        // TODO: Unauthorized page?
        router.push({name: 'logout'});
      }
    } else {
      router.push('/');
    }
  },
  methods: {}
};
</script>
<style lang="scss">
@import "@/assets/styles/common/_variables.scss";
</style>



// WEBPACK FOOTER //
// src/views/auth/Login.vue